import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	gap: 1rem;
	padding: 2rem;
`

export const Label = styled.p`
	font-size: 0.95rem;
	color: #6c757d;
	margin: 0;
	font-weight: 500;
`
